/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";

import Button from "../../../component/button/Button";
import SelectInput2 from "../../../component/input/SelectInput2";
import TextInput2 from "../../../component/input/TextInput2";
import SpinnerButton from "../../../component/spinner/SpinnerButton";
import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction
} from "../../../constant/helper/helper";
import { loginTypeConstant } from "../../../constant/loginType/loginTypeConstant";
import ReactTooltip from "react-tooltip";

const TopInput = ({
  values,
  allUsers,
  onSubmit,
  loginType,
  userLoading,
  currentUser,
  allLocations,
  onUserSelect,
  onLocationChange,
  handleInputChange
}) => (
  <div className="row">
    <ReactTooltip id="date" place="top" effect="solid" type="info">
      Select Date
    </ReactTooltip>
    <ReactTooltip
      id="locationId"
      place="top"
      effect="solid"
      type="info"
    >
      Select Location to Get the Users Attendance
    </ReactTooltip>
    <ReactTooltip id="userId" place="top" effect="solid" type="info">
      Select Employee Name
    </ReactTooltip>
    <ReactTooltip
      id="fromDate"
      place="top"
      effect="solid"
      type="info"
    >
      Select from date
    </ReactTooltip>
    <ReactTooltip id="toDate" place="top" effect="solid" type="info">
      Select to date
    </ReactTooltip>

    <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12">
      <div className="row">
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
          <SelectInput2
            data-tip
            isLabeled={true}
            name="locationId"
            data-for="locationId"
            label="Select Location"
            onChange={onLocationChange}
            value={values.locationId}
            placeholder="Select Location"
            icon="mdi mdi-map-marker-radius"
          >
            {isSuperAdmin(currentUser)
              ? renderLocationFunction(allLocations)
              : renderAccessLocation2(
                  locationRender(currentUser, false)
                )}
          </SelectInput2>
        </div>
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
          <SelectInput2
            data-tip
            name="userId"
            isLabeled={true}
            data-for="userId"
            label="Select User"
            value={values.userId}
            icon="mdi mdi-account"
            onChange={onUserSelect}
            placeholder="Select User"
          >
            {allUsers.map((userData, i) => (
              <option key={i} value={userData._id}>
                {userData.workerFirstName +
                  " " +
                  userData.workerSurname}
              </option>
            ))}
          </SelectInput2>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 mt-3">
          <TextInput2
            data-tip
            type="date"
            name="fromDate"
            data-for="fromDate"
            value={values.fromDate}
            onChange={handleInputChange}
            icon="mdi mdi-calendar-check"
            placeholder="Select From Date"
          />
        </div>
        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 mt-3">
          <TextInput2
            data-tip
            type="date"
            name="toDate"
            data-for="toDate"
            value={values.toDate}
            onChange={handleInputChange}
            placeholder="Select To Date"
            icon="mdi mdi-calendar-check"
          />
        </div>
        {userLoading ? (
          <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 mt-3">
            <SpinnerButton />
          </div>
        ) : (
          <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 mt-3">
            <div className="form-group">
              <Button
                title="GET"
                type="button"
                onClick={onSubmit}
                isBackgroundColor={false}
                icon="mdi mdi-plus-circle-outline mr-2"
                className="btn mb-2 text-white btn-dark btn-block"
              />
            </div>
          </div>
        )}
      </div>
    </div>

    <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12">
      <div className="card bg-primary">
        <div className="card-body profile-user-box">
          <div className="media">
            <div className="media-body">
              <h4 className="mt-1 mb-1 text-white">
                {values.userData.workerFirstName +
                  " " +
                  values.userData.workerSurname}
              </h4>
              <ul className="mb-0 list-inline text-light">
                <li className="list-inline-item mr-3">
                  <h5 className="mb-1">{values.userData.workerId}</h5>
                  <p className="mb-0 font-13 text-white-50">
                    {loginType === loginTypeConstant.Employee
                      ? "Employee ID"
                      : "Worker ID"}
                  </p>
                </li>
                <li className="list-inline-item">
                  <h5 className="mb-1">
                    {values.userData.isActive
                      ? "REGULAR"
                      : "DE-ACTIVATE"}
                  </h5>
                  <p className="mb-0 font-13 text-white-50">Status</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

TopInput.propTypes = {
  values: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  allUsers: PropTypes.array.isRequired,
  loginType: PropTypes.string.isRequired,
  userLoading: PropTypes.bool.isRequired,
  onUserSelect: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  allLocations: PropTypes.array.isRequired,
  onLocationChange: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired
};

export default TopInput;
